
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internal-blog",
      function () {
        return require("private-next-pages/internal-blog.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internal-blog"])
      });
    }
  